export const SELECT_THREAD = 'SELECT_THREAD';
export const CLEAR_SELECTED_THREAD = 'CLEAR_SELECTED_THREAD';